export function formatCurrencyBrl(value: number): string {
	return new Intl.NumberFormat("pt-BR", {
		style: "currency",
		currency: "BRL",
	}).format(value);
}

export function truncateText(text: string, maxLength: number): string {
	if (text.length <= maxLength) {
		return text;
	}

	return `${text.slice(0, maxLength - 3)}...`;
}

export function formatFileSize(
	bytes: number | null | undefined
): string | null {
	if (bytes === null || bytes === undefined || bytes <= 0) {
		return null;
	}

	if (bytes < 1024) {
		return `${bytes} B`;
	}

	if (bytes < 1024 * 1024) {
		return `${(bytes / 1024).toFixed(1)} KB`;
	}

	return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

const CNPJ_MASK_REGEX = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/;

export function formatCnpj(value: string | null | undefined): string {
	if (!value) {
		return "—";
	}

	const digits = value.replace(/\D/g, "");
	if (digits.length !== 14) {
		return value;
	}

	return digits.replace(CNPJ_MASK_REGEX, "$1.$2.$3/$4-$5");
}

const WHITESPACE_SPLIT_REGEX = /\s+/;

export function getDriverInitials(name: string | null | undefined): string {
	if (!name?.trim()) {
		return "?";
	}

	const parts = name.trim().split(WHITESPACE_SPLIT_REGEX).filter(Boolean);
	if (parts.length === 1) {
		return parts[0].slice(0, 2).toUpperCase();
	}

	const lastPart = parts.at(-1);
	return `${parts[0][0] ?? ""}${lastPart?.[0] ?? ""}`.toUpperCase();
}

/** Máscara parcial conforme Figma (ex.: CPF: *.123.456-**). */
export function formatDriverCpfPartial(cpf: string | null | undefined): string {
	if (!cpf?.trim()) {
		return "CPF não informado";
	}

	const digits = cpf.replace(/\D/g, "");
	if (digits.length !== 11) {
		return `CPF: ${cpf.trim()}`;
	}

	return `CPF: *.${digits.slice(1, 4)}.${digits.slice(4, 7)}-**`;
}
